import React from "react";
import { Box, Tab, Typography } from "@mui/material";

import { SubscriptionUsageType } from "fond/api/accountSlice";
import { Usage } from "fond/types";
import { BlockSpinner } from "fond/widgets";
import { RoutedTabsContainer } from "fond/widgets/RoutedTabs.styles";

import InsightsOverview from "../InsightsOverview/InsightsOverview";

import { UsageTypeTabs } from "./insightsPage.styles";

interface InsightsPageProps {
  subscriptionUsage?: Usage;
  usageType: SubscriptionUsageType;
  showUsageTypeTabs?: boolean;
  onUsageTypeChange?: (type: SubscriptionUsageType) => void;
}

const InsightsPage: React.FC<InsightsPageProps> = ({
  subscriptionUsage,
  usageType,
  showUsageTypeTabs = false,
  onUsageTypeChange,
}: InsightsPageProps) => {
  return (
    <Box>
      <Typography variant="h2">Analytics</Typography>
      <Box pt={4}>
        <RoutedTabsContainer data-testid="insights-analytics">
          {showUsageTypeTabs && (
            <UsageTypeTabs aria-label="Usage type" value={usageType} onChange={(_, value: SubscriptionUsageType) => onUsageTypeChange?.(value)}>
              <Tab value="planner" label="Planner" data-testid="insights-tab-planner" />
              <Tab value="design" label="Design" data-testid="insights-tab-design" />
            </UsageTypeTabs>
          )}
          {subscriptionUsage ? (
            <InsightsOverview subscriptionUsage={subscriptionUsage} usageType={usageType} showHeader={!showUsageTypeTabs} />
          ) : (
            <BlockSpinner />
          )}
        </RoutedTabsContainer>
      </Box>
    </Box>
  );
};

export default InsightsPage;
